export default __webpack_public_path__ + "static/media/logo-long-white.d9b3b879.svg";